import React, { useEffect, useState } from "react";
import './invoice-component.scss'
import sortIcon from '../../../assets/images/help-filter.svg'
import filterIcon from '../../../assets/images/help-filter-2.svg'
import RightArrow from "../../../assets/images/help-invoice-rightArrow.svg";
import CalendarImg from "../../../assets/images/calendar-icon.svg";
import Trucks from "../../../assets/images/truck-delivery.svg";
import dayjs from "dayjs";
import { Button, Col, Collapse, Drawer, Pagination, Radio, Row, Space, Spin, DatePicker } from "antd";
import InvoiceRightModal from "./invoice-right-modal";
import PodUploadModel from "../../home/components/pod-upload-model";
import moment from "moment";
import { useTranslation } from "react-i18next";
import NodataImg from "../../../assets/images/nodata-img.svg";
import DecimalFormatter from "../../../common/decimal-converter/decimal-converter";
import { MultiSelectFilterSearch } from "../../loads/component/multi-select-filter-search/multi-select-filter-search";
import ArrowRight from "../../../assets/images/order-right-arrow-big.svg";
import TruckItems from "../../../assets/images/truck-items.svg";
import DontFindOrder from "./dont-find-order-model";
import TripDetailsDrawer from "./trip-details-drawer";
import { SwapOutlined, ArrowRightOutlined, DownOutlined, CloseOutlined, UpOutlined } from "@ant-design/icons";
import * as orderService from "../../../service/order/orderService"
import { useStore } from "../../../store/store";
import { checkIsInternalSourcing, checkIsKSAOperatingCountry, checkIsTurkeyKazak, checkIsUAEOperatingCountry } from "../../../util/constantUtility";
import { RaiseOrderList } from "../../../service/helpAndSupport/helpAndSupportService";
import * as localStorageService from "../../../service/localStorageService";
import { LocalStorageKeys } from "../../../constants/localStorageKeys";
import { CommonConstants } from "../../../constants/commonConstants";
const { RangePicker } = DatePicker;

const { Panel } = Collapse;
const InvoiceComponent = ({setPageRefresh,pageRefresh,fromDateDefault,toDateDefault}) => {
    const { t } = useTranslation();
    const { user } = useStore();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10)
    const [totalRecord, setTotalRecords] = useState(0);

    const [isAdditionalFilterMasterDataLoader, setIsAdditionalFilterMasterDataLoader] = useState(true);
    const [isOpenTripDetailsDrawer, setTripDetailsDrawer] = useState(false)
    const [tripOrderId, setTripOrderId] = useState('');
    const [isInvoiceOpen, setIsInvoiceOpen] = useState(false)
    const [invoiceId, setInvoiceID] = useState('')
    const [dontFindOrder, setDontFindOrder] = useState(false)
    const [sortByModal, setSortByModal] = useState(false);
    const [orderList, setOrderList] = useState([])
    const [orderType, setOrderType] = useState('Ongoing');
    const [loader, setLoader] = useState(false);
    const [tempSortBy, setTempSortBy] = useState("");
    const [tempSortOrder, setTempSortOrder] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [isRequireToCheckSearchEnable, setIsRequireToCheckSearchEnable] = useState(false);
    const [sortOrder, setSortOrder] = useState("");
    const [filterModal, setFilterModal] = useState(false);
    const [isAllCountrySelected, setIsAllCountrySelected] = useState(true);
    const [selectedFromToCountry, setSelectedFromToCountry] = useState(null);
    const [applyFilter, setApplyFilter] = useState(false);
    const [applyQuickFilter, setApplyQuickFilter] = useState(false);
    const [applyStateLoadsFilter, setApplyStateLoadsFilter] = useState(false);
    const [applyCountryQuickFilter, setApplyCountryQuickFilter] = useState(false);

    const [isCountryListLoader, setIsCountryListLoader] = useState(false);
    const [isPreferenceChangeApply, setIsPreferenceChangeApply] = useState(false);
    const [isRequireToLoadFromAndToStateMasterData, setIsRequireToLoadFromAndToStateMasterData] = useState(false);
    const [liveLoadsListCountryWise, setLiveLoadsListCountryWise] = useState([]);
    const [ordersFilter, setordersFilter] = useState({
        source: {
            label: "",
            value: "",
            country: "",
            city: "",
            state: "",
            type: "",
        },
        destination: {
            label: "",
            value: "",
            country: "",
            city: "",
            state: "",
            type: "",
        },
        moveDate: { fromDate:fromDateDefault ? fromDateDefault:new Date('2025-04-01').toISOString().split('T')[0], toDate:toDateDefault ? toDateDefault:new Date().toISOString().split('T')[0] },
        shippers: [],
        sourceCountries: [],
        sourceStates: [],
        sourceCities: [],
        destinationCountries: [],
        destinationStates: [],
        destinationCities: [],
        moveType: "",
        truckTypes: "",
        truckNumbers: [],
        orderIds: [],
        driverIds: [],
        isLoadFromPreferences: false,
        sourceAndDestinationStates: [],
    });

    const [additionalFilterMasterData, setAdditionalFilterMasterData] = useState({
        shippers: [],
        sourceCountries: [],
        sourceStates: [],
        sourceCities: [],
        destinationCountries: [],
        destinationStates: [],
        destinationCities: [],
        truckTypes: [],
        truckNumbers: [],
        orderIds: [],
        drivers: [],
        subTruckTypes: [],
    });
    const [appliedFilterCount, setAppliedFilterCount] = useState(0);
    const clearGloalFilter = (localLiveLoadsFilter) => {
        localLiveLoadsFilter.source = {
            city: "",
            value: "",
            state: "",
            country: "",
            type: "",
            newName: "",
        };
        localLiveLoadsFilter.destination = {
            city: "",
            value: "",
            state: "",
            country: "",
            type: "",
            newName: "",
        };
        localLiveLoadsFilter.moveDate = { fromDate:new Date('2025-04-01').toISOString().split('T')[0], toDate: new Date().toISOString().split('T')[0] };
        localLiveLoadsFilter.inquiryID = "";
        let localDateRangeFilter = { ...dateRange };
            let selectedMoveDate = {
                fromDate: new Date('2025-04-01').toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0],
            };
            localDateRangeFilter.moveDate = selectedMoveDate;
            setDateRange(localDateRangeFilter);
        return localLiveLoadsFilter;
    };
    const clearAdditionalFilter = (localLiveLoadsFilter) => {
        localLiveLoadsFilter.shippers = [];
        localLiveLoadsFilter.orderIds = [];
        localLiveLoadsFilter.sourceCountries = [];
        localLiveLoadsFilter.sourceStates = [];
        localLiveLoadsFilter.sourceCities = [];
        localLiveLoadsFilter.destinationCountries = [];
        localLiveLoadsFilter.destinationStates = [];
        localLiveLoadsFilter.destinationCities = [];
        localLiveLoadsFilter.moveType = [];
        localLiveLoadsFilter.truckTypes = [];
        localLiveLoadsFilter.truckNumbers = [];
        localLiveLoadsFilter.subTruckTypes = [];
        return localLiveLoadsFilter;
    };
 const [dateRange, setDateRange] = useState({
        moveDate: {
            fromDate:ordersFilter?.moveDate?.fromDate ? ordersFilter?.moveDate?.fromDate:new Date('2025-04-01').toISOString().split('T')[0],
            toDate:ordersFilter?.moveDate?.toDate ? ordersFilter?.moveDate?.toDate : new Date().toISOString().split('T')[0]
        },
    });

        // Handle Date Range Change
    const handleDateChange = (dates, dateString) => {
        let localfilter = {...ordersFilter}
        let selectedMoveDate = { fromDate: "", toDate: "" };
        if (dateString?.length == 2 && dateString[0] && dateString[1]) {
            let localLiveLoadsFilter = { ...dateRange };
            selectedMoveDate = {
                fromDate: dateString[0],
                toDate: dateString[1],
            };
            localLiveLoadsFilter.moveDate = selectedMoveDate;
            setDateRange(localLiveLoadsFilter);
        } else {
            let localLiveLoadsFilter = { ...dateRange };
            localLiveLoadsFilter.moveDate = selectedMoveDate;
            setDateRange(localLiveLoadsFilter);
        }
        console.log(selectedMoveDate.fromDate,'data')
localfilter.moveDate=selectedMoveDate;
setordersFilter(localfilter)

    };
    useEffect(() => {
        getOrderList()
        getAdditionalFilterMasterData();
    }, [orderType, sortBy, sortOrder , currentPage,applyFilter,sortByModal])
    const getOrderList = () => {
       const languageISOCode=localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
        const payload = {
            supplierId: user?.userId,
            // type: orderType,
            // shipperIds: ordersFilter.shippers.length > 0 ? ordersFilter.shippers.map((shipper) => shipper.shipperId) : [],
            orderIds: ordersFilter.orderIds?.length > 0 ? ordersFilter.orderIds : [],

            // sourceCountries: ordersFilter.sourceCountries?.length > 0 ? ordersFilter.sourceCountries
            // : ordersFilter.source?.type == "country" ? [ordersFilter.source?.value] : [],

            // destinationCountries: ordersFilter.destinationCountries?.length > 0 ? ordersFilter.destinationCountries
            // : ordersFilter.destination?.type == "country" ? [ordersFilter.destination?.value] : [],

            // sourceStates: ordersFilter.sourceStates?.length > 0 ? ordersFilter.sourceStates
            // : ordersFilter.source?.type == "state" ? [ordersFilter.source?.value] : [],
            // 
            // destinationStates: ordersFilter.destinationStates?.length > 0 ? ordersFilter.destinationStates
            // : ordersFilter.destination?.type == "state" ? [ordersFilter.destination?.value] : [],

            sourceCities: ordersFilter.sourceCities?.length > 0 ? ordersFilter.sourceCities
                : ordersFilter.source?.type == "city" ? [ordersFilter.source?.value] : [],

            destinationCities: ordersFilter.destinationCities?.length > 0 ? ordersFilter.destinationCities
                : ordersFilter.destination?.type == "city" ? [ordersFilter.destination?.value] : [],

            fromMoveDate: null,
            toMoveDate: null,
            truckTypes: ordersFilter.truckTypes?.length > 0 ? ordersFilter.truckTypes : [],
            // truckNumbers: ordersFilter.truckNumbers?.length > 0 ? ordersFilter.truckNumbers : [],
            // driverIds: ordersFilter.driverIds?.length > 0 ? ordersFilter.driverIds : [],
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageSize: pageSize,
            pageNumber: currentPage,
            languageISOCode:languageISOCode,
        }

        if (ordersFilter.moveDate.fromDate && ordersFilter.moveDate.toDate) {
            payload.fromMoveDate = ordersFilter.moveDate.fromDate + "T00:00:00";
            payload.toMoveDate = ordersFilter.moveDate.toDate + "T23:59:59";
        }

        setLoader(true);
        RaiseOrderList(payload)
            .then((response) => {
                if (response.status === 200) {
                    setLoader(false);
                   setOrderList(response?.data?.data);
                    setCurrentPage(response?.data?.pagination?.pageNumber);
                    setPageSize(response?.data?.pagination?.pageSize)
                    setTotalRecords(response?.data?.pagination?.totalRecords)
                }
            })
            .catch((error) => {
                setLoader(false);
                // console.error("Error fetching order list:", error);
                setOrderList([]);
            });
    };
    const getAppliedFilterCount = () => {
        const filters = [ordersFilter?.shippers, ordersFilter.sourceStates, ordersFilter?.sourceCities, ordersFilter?.destinationStates, ordersFilter?.destinationCities, ordersFilter?.truckTypes, ordersFilter?.truckNumbers, ordersFilter?.orderIds];
        const count = filters.filter(filter => Array.isArray(filter) && filter.length > 0).length;
        setAppliedFilterCount(count);
    };

    const getCity = cityString => cityString.split(',')[0];
    const handleCardClick = (orderID) => {
        if (isOpenTripDetailsDrawer === false) {
            setTripOrderId(orderID);
            setTripDetailsDrawer(true)
        }
    }

    const handleSortChange = (category, order) => {
        setTempSortBy(category);
        setTempSortOrder(order);
    };

    const handleApplySort = () => {
        setSortBy(tempSortBy);
        setSortOrder(tempSortOrder);
        setSortByModal(!sortByModal);
    };
    const clearSortHandler = () => {
        setTempSortBy("")
        setTempSortOrder("")
        setSortBy("")
        setSortOrder("")
        setSortByModal(!sortByModal)
    }
    const handleApplyAdditionalFilter = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        const selectedMoveDate = localLiveLoadsFilter.moveDate;
        localLiveLoadsFilter = clearGloalFilter(localLiveLoadsFilter);
        localLiveLoadsFilter.moveDate = selectedMoveDate;
        localLiveLoadsFilter.isGlobalSearchPerformed = false;
        setordersFilter(localLiveLoadsFilter);
        setIsAllCountrySelected(false);
        setSelectedFromToCountry(null);
        setIsRequireToCheckSearchEnable(true);
        setFilterModal(false);
        setApplyFilter(!applyFilter);
        getAppliedFilterCount();
    };

    const handleClearAdditionalFilter = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter = clearAdditionalFilter(localLiveLoadsFilter);
        localLiveLoadsFilter = clearGloalFilter(localLiveLoadsFilter);
        localLiveLoadsFilter.isGlobalSearchPerformed = false;
        setordersFilter(localLiveLoadsFilter);
        setIsAllCountrySelected(true);
        setIsRequireToCheckSearchEnable(true);
        setFilterModal(false);
        setApplyFilter(!applyFilter);
        setAppliedFilterCount(0);
    };
    const handleSelectSourceState = (values) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.sourceStates = values;
        setordersFilter(localLiveLoadsFilter);
    };

    //clear source state
    const clearSourceStates = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.sourceStates = [];
        setordersFilter(localLiveLoadsFilter);
    };


    const clearDestinationStates = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.destinationStates = [];
        setordersFilter(localLiveLoadsFilter);
    };

    const clearSourceCities = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.sourceCities = [];
        setordersFilter(localLiveLoadsFilter);
    };

    const clearDestinationCities = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.destinationCities = [];
        setordersFilter(localLiveLoadsFilter);
    };

    const clearShipper = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.shippers = [];
        setordersFilter(localLiveLoadsFilter);
    };


    const clearOrderId = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.orderIds = [];
        setordersFilter(localLiveLoadsFilter);
    };


    const clearTruckTypes = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.truckTypes = [];
        setordersFilter(localLiveLoadsFilter);
    };

    const clearTruckNumbers = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.truckNumbers = [];
        setordersFilter(localLiveLoadsFilter);
    };
    const handleSelectSourceCity = (values) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.sourceCities = values;
        setordersFilter(localLiveLoadsFilter);
    };

    //select source city handle
    const handleSelectOrderId = (values) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.orderIds = values;
        setordersFilter(localLiveLoadsFilter);
    };

    //select destination state handle
    const handleSelectDestinationState = (values) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.destinationStates = values;
        setordersFilter(localLiveLoadsFilter);
    };

    //select destination city handle
    const handleSelectDestinationCity = (values) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.destinationCities = values;
        setordersFilter(localLiveLoadsFilter);
    };

    //select move type handle
    const handleSelectMoveType = (value) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.moveType = value;
        setordersFilter(localLiveLoadsFilter);
    };

    //select truck type handle
    const handleSelectTruckType = (value) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.truckTypes = value;
        setordersFilter(localLiveLoadsFilter);
    };

    //select truck numbers handle
    const handleSelectTruckNumbers = (value) => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter.truckNumbers = value;
        setordersFilter(localLiveLoadsFilter);
    };

    const handleChangePage = (page) => {
        setCurrentPage(page);
    };
    function hasValidValues(obj) {
        if (obj?.moveDate?.fromDate && obj?.moveDate?.toDate) return true;
        return Object.keys(obj).some(key => {
            if (key === "source" || key === "destination" || key === "moveDate" || key === "isLoadFromPreferences" || key === "isGlobalSearchPerformed") return false;

            let value = obj[key];

            if (Array.isArray(value)) {
                return value.length > 0;
            }
            else if (typeof value === "object" && value !== null) {
                return hasValidValues(value);
            }
            else {
                return value !== "" && value !== null && value !== undefined;
            }
        });
    }
    const handleSourceStateMoreFilterApply = () => {
        let localLiveLoadsFilter = { ...ordersFilter };
        localLiveLoadsFilter = clearGloalFilter(localLiveLoadsFilter);
        localLiveLoadsFilter.isGlobalSearchPerformed = false;
        setordersFilter(localLiveLoadsFilter);
        setIsAllCountrySelected(false);
        setSelectedFromToCountry(null);
        setIsRequireToCheckSearchEnable(true);
        setApplyFilter(true);
    };
    const handleSelectShipper = (option) => {
        // let localLiveLoadsFilter = { ...ordersFilter };
        // localLiveLoadsFilter.shippers = {
        //   label: selectedShipper.label,
        //   value: selectedShipper.value,
        //   shipperId: selectedShipper.value,
        //   shipperName: selectedShipper.label,
        // };
        const selectedShippers = additionalFilterMasterData.shippers.filter((shipper) => option.includes(shipper.value));

        setordersFilter((prevFilter) => ({
            ...prevFilter,
            shippers: selectedShippers.map((shipper) => ({
                label: shipper.label,
                value: shipper.value,
                shipperId: shipper.value,
                shipperName: shipper.label,
            })),
        }));
    };
    const getAdditionalFilterMasterData = () => {
        setAdditionalFilterMasterData({
            shippers: [],
            sourceCountries: [],
            sourceStates: [],
            sourceCities: [],
            destinationCountries: [],
            destinationStates: [],
            destinationCities: [],
            truckTypes: [],
            truckNumbers: [],
            orderIds: [],
            drivers: [],
            subTruckTypes: [],
        });
        if (!isAdditionalFilterMasterDataLoader) {
            setIsAdditionalFilterMasterDataLoader(true);
        }
        orderService.getOrderFilterMasterData()
            .then((res) => {
                setIsAdditionalFilterMasterDataLoader(false);
                if (res?.data?.data) {
                    let data = { ...res?.data?.data };
                    let localAdditionalFilter = {
                        shippers: [],
                        sourceCountries: [],
                        sourceStates: [],
                        sourceCities: [],
                        destinationCountries: [],
                        destinationStates: [],
                        destinationCities: [],
                        truckTypes: [],
                        truckNumbers: [],
                        orderIds: [],
                        drivers: [],
                        subTruckTypes: [],
                    };
                    if (data?.sourceCountries?.length > 0) {
                        localAdditionalFilter.sourceCountries = mapToLabelValue(data.sourceCountries);
                    }
                    if (data?.sourceStates?.length > 0) {
                        localAdditionalFilter.sourceStates = mapToLabelValue(data.sourceStates);
                    }
                    if (data?.sourceCities?.length > 0) {
                        localAdditionalFilter.sourceCities = mapToLabelValue(data.sourceCities);
                    }
                    if (data?.destinationCountries?.length > 0) {
                        localAdditionalFilter.destinationCountries = mapToLabelValue(data.destinationCountries);
                    }
                    if (data?.destinationStates?.length > 0) {
                        localAdditionalFilter.destinationStates = mapToLabelValue(data.destinationStates);
                    }
                    if (data?.destinationCities?.length > 0) {
                        localAdditionalFilter.destinationCities = mapToLabelValue(data.destinationCities);
                    }
                    if (data?.shippers?.length > 0) {
                        localAdditionalFilter.shippers = mapToLabelValueShipper(data.shippers);
                    }
                    if (data?.orderIds?.length > 0) {
                        localAdditionalFilter.orderIds = mapToLabelValue(data.orderIds);
                    }
                    if (data?.truckTypes?.length > 0) {
                        localAdditionalFilter.truckTypes = mapToLabelValue(data.truckTypes);
                    }
                    if (data?.truckNumbers?.length > 0) {
                        localAdditionalFilter.truckNumbers = mapToLabelValue(data.truckNumbers);
                    }
                    setAdditionalFilterMasterData(localAdditionalFilter);
                }
            })
            .catch((error) => {
                setIsAdditionalFilterMasterDataLoader(false);
            });
    };
    const mapToLabelValue = (arr) => arr.map((z) => ({ label: z, value: z }));

    const mapToLabelValueShipper = (arr) => arr.map((z) => ({ label: z.shipperName, value: z.shipperId }));

    return (
        <div className="invoice-component-wrapper">
            <Row className='invoice-message-wrapper'>

                <span className='invoice-message'>{t("NEED_HELP_INVOICE_RAISE_ISSUE")} <span className="dont-find-order" onClick={() => setDontFindOrder(true)}>{t("NEED_HELP_INVOICE_DONT_FIND_ORDER")}</span></span>
                <div className="btn-filter-wrapper">
                    <Button className="filter-btn" onClick={() => setFilterModal(true)}><img src={filterIcon} alt="icon" />{t("NEED_HELP_INVOICE_FILTERS")}</Button>
                    <Button className="sort-btn" onClick={() => setSortByModal(true)}><img src={sortIcon} alt="icon" />{t("NEED_HELP_INVOICE_SORT_BY")}</Button>
                </div>
            </Row>
            {/* <Row className="invoice-filter-row">
               
                <Button className="invoice-btn">Invoice Status</Button>
                <Button className="date-btn">Date Range</Button>
            </Row> */}
            {loader ? <Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin> : 
            orderList.length>0 ?<Row className="Invoice-card-row-wrapper">

                {orderList?.map((item, index) => {
                    return (
                        <div className="invoice-div-wrapper" onClick={() => handleCardClick(item?.orderNumber)}>
                            <Row className="order-id-row">
                                <div className="order-number-text">
                                    {item?.orderNumber}
                                </div>
                                <div className="date-calendar">
                                    <span><img src={CalendarImg} /></span>
                                    <span> {moment.utc(item?.moveDate).format("DD/MM/YYYY HH:mm")}</span>
                                </div>
                            </Row>

                            <Row className="orders-price-row">
                                <Col span={16} className="orders-total-earning-col">
                                    <span className="orders-industry-type">{item?.shipperName}</span>
                                    {!item?.supplierInfo &&
                                        <span className="orders-item-price">
                                            {item?.currency} {" "}
                                            {/* {item.amount} */}
                                            <DecimalFormatter amount={item?.amount} country={checkIsTurkeyKazak(item?.operatingCountry) ? "TRY" : item?.currency} flag={false} isShowDecimal={true}/>&nbsp;
                                            <span className="orders-Total-Earnings">{t("ORDER_TOTAL_EARNINGS")}</span>
                                        </span>
                                    }
                                </Col>
                                <Col span={8} className="orders-truck-type">
                                    <span><img src={Trucks} alt="truck" /></span>
                                    <span className="orders-truck-details">
                                        <span className="orders-truck-details-value">{item?.assetType}-{item?.assetSubType}</span>
                                        <span className="orders-no-of-trucks">
                                            <span className="orders-comman-class-number-of-truck"><span className="orders-comman-class-no-of-truck-value">{item?.noOfAssets}</span> {t("ORDER_TRUCK")}</span>
                                            <span className="orders-comman-class-number-of-truck"><span className="orders-comman-class-no-of-truck-value">{item?.maxWeight} </span>{t("ORDER_TONS_TRUCK")}</span>
                                        </span>
                                    </span>
                                </Col>
                            </Row>

                            <Row className="orders-order-trip-row">
                                <Col span={16} className="orders-order-trip-row-one">
                                    <span className="orders-source-city">{getCity(item?.fromCity)}
                                        <span className="orders-city">
                                            {item?.fromCountry}
                                        </span>
                                    </span>
                                    <span className="loads-right-arrow">
                                        <img src={ArrowRight} className="arrow-img" />
                                        {item?.isMultiRoute &&
                                            <span>{t("NEED_HELP_INVOICE_MULTI_ROUTE")}</span>
                                        }
                                    </span>
                                    {/* <div>
                            <img src={ArrowRight} />
                          </div> */}
                                    <span className="orders-source-city">{getCity(item?.toCity)}
                                        <span className="orders-city">
                                            {item?.toCountry}
                                        </span>

                                    </span>
                                </Col>
                                <Col span={8} className="orders-order-trip-row-two">
                                    <div></div>
                                    <Space>
                                        <img src={TruckItems} alt="" />
                                        <div>
                                            <span>
                                                {/* {item?.commodity} */}
                                                {item?.localizeCommodityName ? item?.localizeCommodityName:item?.commodity}
                                            </span>
                                        </div>
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    )
                })}
                <div style={{display:'flex', justifyContent:'flex-end'}}>
                <Pagination
                    current={currentPage}   // The current page number
                    pageSize={pageSize}     // The number of items per page
                    onChange={handleChangePage}  // The function to call when the page is changed
                    total={totalRecord}     // The total number of items (for calculating total pages)
                />
                </div>
            </Row>:<Row justify={'center'} style={{ height: '60vh' }}>
                    <img src={NodataImg} alt='no data' />
                </Row>
            }
            {isInvoiceOpen && <InvoiceRightModal OrderId={tripOrderId} isOpen={isInvoiceOpen} setIsOpen={setIsInvoiceOpen} />}
            {dontFindOrder && <DontFindOrder setDontFindOrder={setDontFindOrder} dontFindOrder={dontFindOrder} setPageRefresh={setPageRefresh} pageRefresh={pageRefresh} />}
            {isOpenTripDetailsDrawer && <TripDetailsDrawer orderID={tripOrderId} setTripDetailsDrawer={setTripDetailsDrawer} isOpenTripDetailsDrawer={isOpenTripDetailsDrawer} />}
            {sortByModal &&
                <Drawer
                    drawer
                    placement="right"
                    visible={sortByModal}
                    onClose={() => setSortByModal(false)}
                    width={600} className="orders-reverse-modal"
                    title={
                        <>
                            <div className="orders-title-filter-modal">
                                <span>{t("LOADS_SORT_BY")}</span>
                                <Space direction="horizontal">
                                    <Button type="link" onClick={clearSortHandler} className="orders-clear-filters">
                                        {t("NEED_HELP_CLEAR")}
                                    </Button>
                                </Space>
                            </div>
                        </>
                    }
                >
                    <div>
                        <div className="orders-sort-section">
                            <h4>{t("ORDER_EARNINGS")}</h4>
                            <Radio.Group onChange={(e) => handleSortChange("earning", e.target.value)} value={tempSortBy === "earning" ? tempSortOrder : null}>
                                <Radio value="asc">{t("ORDER_LOWEST_HIGHEST")}</Radio>
                                <Radio value="desc">{t("ORDER_HIGHEST_LOWEST")}</Radio>
                            </Radio.Group>
                        </div>

                        <div className="orders-sort-section">
                            <h4>{t("ORDER_MOVE_DATE")}</h4>
                            <Radio.Group onChange={(e) => handleSortChange("moveDate", e.target.value)} value={tempSortBy === "moveDate" ? tempSortOrder : null}>
                                <Radio value="desc">{t("LOADS_LATEST_OLDEST")}</Radio>
                                <Radio value="asc">{t("LOADS_OLDEST_EARLIEST")}</Radio>
                            </Radio.Group>
                        </div>

                        <div className="orders-sort-section">
                            <h4>{t("ORDER_ORDERS_STATUS")}</h4>
                            <Radio.Group onChange={(e) => handleSortChange("ongoing", e.target.value)} value={tempSortBy === "ongoing" ? tempSortOrder : null}>
                                <Radio value="asc">{t("ORDER_ONGOING_FIRST")}</Radio>
                                <Radio value="desc">{t("ORDER_UPCOMING_FIRST")}</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <Row justify={'center'} className="orders-button-row">
                        <Button
                            type="secondary" className="orders-cancel-btn"
                            onClick={() => {
                                setSortByModal(false);
                                setTempSortBy("")
                            }}
                        >
                            {t("COMMON_CANCEL_BTN")}
                        </Button>
                        <Button type="secondary"
                            disabled={!tempSortOrder} className={!tempSortOrder ? "orders-submit-btn-disabled" : "orders-submit-btn"}
                            onClick={handleApplySort}>{t("ORDER_APPLY_FILTERS")}</Button>
                    </Row>
                </Drawer>
            }

            {filterModal &&
                <Drawer
                    drawer
                    placement="right"
                    visible={filterModal}
                    closable={false}
                    width={600} className="orders-reverse-modal"
                    title={
                        <>
                            <div className="orders-title-filter-modal">
                                <span>{t("MORE_FILTERS")}</span>
                                <Space direction="horizontal">
                                    <Button
                                        type="link"
                                        onClick={handleClearAdditionalFilter}
                                        className="orders-clear-filters"
                                    >
                                        {t("CLEAR_FILTERS")}
                                    </Button>
                                </Space>
                                <Button
                                    icon={<CloseOutlined />}
                                    type="text"
                                    onClick={() => setFilterModal(false)}
                                    style={{ fontSize: "16px" }}
                                />
                            </div>
                        </>
                    }
                >
                    <div className="orders-filter-holder">
                        {/* <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"sourceStateFilter"} header={
                                <>
                                    {checkIsUAEOperatingCountry(user?.operatingCountry) ? t("LOADS_SOURCE_EMIRATE") : checkIsKSAOperatingCountry(user?.operatingCountry) ? t("LOADS_SOURCE_PROVINCE") : t("SOURCE_STATE")}
                                    {
                                        ordersFilter.sourceStates?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.sourceStates?.length}
                                        </span>
                                    }
                                </>
                            }>
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.sourceStates}
                                    onSelectionChange={handleSelectSourceState}
                                    onClear={clearSourceStates}
                                    maxDisplayOptions={1}
                                    initialValue={
                                        ordersFilter.sourceStates?.length > 0
                                            ? ordersFilter.sourceStates
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse> */}
                        <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"sourceCityFilter"} header={
                                <>
                                    {t("SOURCE_CITY")}
                                    {
                                        ordersFilter.sourceCities?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.sourceCities?.length}
                                        </span>
                                    }
                                </>
                            }>
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.sourceCities}
                                    onSelectionChange={handleSelectSourceCity}
                                    onClear={clearSourceCities}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.sourceCities?.length > 0
                                            ? ordersFilter.sourceCities
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse>

                        {/* {checkIsInternalSourcing(user?.userRole) && */}
                        {/* <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"shipperName"} header={
                                <>
                                    {t("CUSTOMER_NAME")}
                                    {
                                        ordersFilter.shippers?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.shippers?.length}
                                        </span>
                                    }
                                </>
                            }>
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.shippers}
                                    onSelectionChange={handleSelectShipper}
                                    onClear={clearShipper}
                                    maxDisplayOptions={4}
                                    // initialValue={
                                    //   ordersFilter.shippers?.length > 0
                                    //     ? ordersFilter.shippers
                                    //     : []
                                    // }
                                    initialValue={
                                        ordersFilter.shippers.length > 0
                                            ? ordersFilter.shippers.map((shipper) => shipper.shipperId)
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse> */}
                        {/* } */}

                        <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"orderIds"} header={
                                <>
                                    {t("ORDER_ID_LBL")}
                                    {
                                        ordersFilter.orderIds?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.orderIds?.length}
                                        </span>
                                    }
                                </>
                            }>
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.orderIds}
                                    onSelectionChange={handleSelectOrderId}
                                    onClear={clearOrderId}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.orderIds?.length > 0
                                            ? ordersFilter.orderIds
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse>

                        {/* <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"destinationStateFilter"} header={
                                <>
                                    {checkIsUAEOperatingCountry(user?.operatingCountry) ? t("LOADS_DESTINATION_EMIRATE") : checkIsKSAOperatingCountry(user?.operatingCountry) ? t("LOADS_DESTINATION_PROVINCE") : t("DESTINATION_STATE")}
                                    {
                                        ordersFilter.destinationStates?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.destinationStates?.length}
                                        </span>
                                    }
                                </>
                            }>
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.destinationStates}
                                    onSelectionChange={handleSelectDestinationState}
                                    onClear={clearDestinationStates}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.destinationStates?.length > 0
                                            ? ordersFilter.destinationStates
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse> */}

                        <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel
                                key={"destinationCityFilter"}
                                header={
                                    <>
                                        {t("DESTINATION_CITY")}
                                        {
                                            ordersFilter.destinationCities?.length > 0 &&
                                            <span className="circle">
                                                {ordersFilter.destinationCities?.length}
                                            </span>
                                        }
                                    </>
                                }
                            >
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.destinationCities}
                                    onSelectionChange={handleSelectDestinationCity}
                                    onClear={clearDestinationCities}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.destinationCities?.length > 0
                                            ? ordersFilter.destinationCities
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse>

                        <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"truckTypeFilter"} header={
                                <>
                                    {t("TRUCK_TYPE")}
                                    {
                                        ordersFilter.truckTypes?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.truckTypes?.length}
                                        </span>
                                    }
                                </>
                            }>
                                {/* <Select
                                          className="orders-select-filter"
                                          options={additionalFilterMasterData.truckTypes}
                                          showSearch
                                          onChange={(val, option) => {
                                            handleSelectTruckType(val, option);
                                          }}
                                          value={ordersFilter.truckTypes}
                                          filterOption={(input, option) =>
                                            option?.label
                                              ?.toLowerCase()
                                              .indexOf(input?.toLowerCase()) >= 0
                                          }
                                        /> */}
                                <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.truckTypes}
                                    onSelectionChange={handleSelectTruckType}
                                    onClear={clearTruckTypes}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.truckTypes?.length > 0
                                            ? ordersFilter.truckTypes
                                            : []
                                    }
                                    title={t("NEED_HELP_TOP_PICKS")}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse>

                         <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"orderIds"} header={
                                <>
                                    {t("NEED_HELP_DFO_MOVE_DATE")}
                                  
                                </>
                            }>
                                <RangePicker
                                value={[
                                    dateRange.moveDate.fromDate
                                        ? dayjs(dateRange.moveDate.fromDate)
                                        : null,
                                    dateRange.moveDate.toDate
                                        ? dayjs(dateRange.moveDate.toDate)
                                        : null,
                                ]} // Bind the state values to the RangePicker
                                // Update state on change
                                onChange={(date, dateString) =>
                                    handleDateChange(date, dateString)
                                }
                            />
                            </Panel>
                        </Collapse>

                        {/* <Collapse
                            className="orders-load-collapse-filter"
                            // activeKey={activeKey} onChange={handlePanelChange}
                            expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                            }
                            expandIconPosition={"right"}
                            accordion={false}
                        >
                            <Panel key={"truckNumberFilter"} header={
                                <>
                                    {t("ORDER_TRUCK_NUMBER")}
                                    {
                                        ordersFilter.truckNumbers?.length > 0 &&
                                        <span className="circle">
                                            {ordersFilter.truckNumbers?.length}
                                        </span>
                                    }
                                </>
                            }>
                                {/* <Select
                                          className="orders-select-filter"
                                          options={additionalFilterMasterData.truckNumbers}
                                          showSearch
                                          onChange={(val, option) => {
                                            handleSelectTruckNumbers(val, option);
                                          }}
                                          value={ordersFilter.truckNumbers}
                                          filterOption={(input, option) =>
                                            option?.label
                                              ?.toLowerCase()
                                              .indexOf(input?.toLowerCase()) >= 0
                                          }
                                        /> */}
                        {/* <MultiSelectFilterSearch
                                    options={additionalFilterMasterData.truckNumbers}
                                    onSelectionChange={handleSelectTruckNumbers}
                                    onClear={clearTruckNumbers}
                                    maxDisplayOptions={4}
                                    initialValue={
                                        ordersFilter.truckNumbers?.length > 0
                                            ? ordersFilter.truckNumbers
                                            : []
                                    }
                                    title={"Top picks"}
                                    isShowMoreFilterCount={true}
                                    onMoreFilterApply={handleSourceStateMoreFilterApply}
                                    loading={isAdditionalFilterMasterDataLoader}
                                />
                            </Panel>
                        </Collapse> */}

                        <Space
                            className="orders-space-horizontal-space"
                            direction="horizontal"
                            size="middle"
                        >
                            <Button
                                type="secondary"
                                className="orders-cancel-btn"
                                onClick={() => {
                                    setFilterModal(false);
                                }}
                            >
                                {t("COMMON_CANCEL_BTN")}
                            </Button>
                            <Button
                                type="secondary"
                                disabled={!hasValidValues(ordersFilter)} className={!hasValidValues(ordersFilter) ? "orders-submit-btn-disabled" : "orders-submit-btn"}
                                onClick={handleApplyAdditionalFilter}
                            >
                                {t("COMMON_APPLY_BTN")}
                            </Button>
                        </Space>
                    </div>
                </Drawer>
            }
        </div>
    )
}
export default InvoiceComponent;
